import { render, staticRenderFns } from "./MovementsPage.vue?vue&type=template&id=0ec30022&scoped=true"
import script from "./MovementsPage.vue?vue&type=script&lang=js"
export * from "./MovementsPage.vue?vue&type=script&lang=js"
import style0 from "./MovementsPage.vue?vue&type=style&index=0&id=0ec30022&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec30022",
  null
  
)

export default component.exports